
import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import axios from 'axios';

const Categories = () => {
  const [merchantId, setMerchantId] = useState(null);
  const [categoryName, setCategoryName] = useState('');
  const [description, setDescription] = useState('');


  const handleSubmit = async (e) => {
    e.preventDefault();


    try {
      const res = await axios.post(
        'https://api.bakpoket.com/api/MerchantCategories', { merchantId, categoryName, description }

      );

      alert('Collection uploaded successfully!');
      // console.log(res.data);

      // reset fields

      setDescription('');
      setCategoryName('');
    } catch (err) {
      console.log('Upload error:', err);
      alert('Upload failed.');
    }
  };

  useEffect(() => {
    const googleLogin = localStorage.getItem('googleLogin');
    if (googleLogin == "false") {
      const merchantData = localStorage.getItem('merchantLogin');
      if (merchantData) {
        const parsedData = JSON.parse(merchantData);
        const id = parsedData.merchantId || parsedData.id;
        if (id) setMerchantId(id);
      }
    }else{
      const merchantData = localStorage.getItem('merchantDashboardLogin');
      if (merchantData) {
        const parsedData = JSON.parse(merchantData);
        const id = parsedData.merchantId || parsedData.id;
        if (id) setMerchantId(id);
      }
    }
  }, []);

  // useEffect(()=>{
  //   alert(merchantId)
  // },[merchantId])

  return (
    <Wrapper>
      <Card>
        <h2>Add New Collection</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Category Name"
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
            required
          />

          <textarea
            placeholder="Collection Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
            className="mb-2"
          />
          <button type="submit">Submit</button>
        </form>
      </Card>
    </Wrapper>
  );
};

export default Categories;


// ✅ Wrapper to center the Card
const Wrapper = styled.section`
  // background-color: #fff;
  width: 100%;
  max-width: 1280px;
  margin: 2% auto;
  padding: 30px;
  border-radius: 15px;

  @media (max-width: 974px) {
    padding: 0px;
    hr {
      margin-top: 0px;
    }
  }

  h3 {
    color: #2a4157;
    font-weight: bold;
    @media (max-width: 576px) {
      font-size: 12px;
      margin-bottom: 0;
    }
    @media (max-width: 974px) {
      margin-bottom: 0;
    }
  }

  .btn {
    padding: 8px 40px;
    background-color: #ef4766;
    color: #fff;
    border-radius: 20px;
    margin-left: 42%;
    @media (max-width: 480px) {
      padding: 3px 18px;
      font-size: 9px;
      margin-top: 8px;
      margin-left: auto;
    }
  }

  .AddCouponsDashboard {
    display: flex;
    flex-direction: column;
  }

  form {
    width: 100%;
    padding: 20px;

    input {
      padding: 20px 0px 20px 20px;
      border-radius: 20px;
      border: 1px solid #999999;
      margin-bottom: 10px;
      @media (max-width: 480px) {
        padding: 4px;
        font-size: 8px;
      }
    }

    @media (max-width: 974px) {
      padding: 4px;
    }
  }

  .hr {
    margin-bottom: 0;
  }

  .hr1 {
    margin-top: 0;
    @media (max-width: 974px) {
      display: none;
    }
  }

  p {
    padding: 15px;
    font-size: 15px;
    width: 90%;
    line-height: 1.4;
    color: #333;
    @media (max-width: 974px) {
      font-size: 11px;
      padding: 10px;
      display: none;
    }
  }

  .form-first-div {
    display: flex;
    gap: 10px;
    @media (max-width: 974px) {
      flex-direction: column;
      gap: 1px;
    }
  }

  .input1,
  .input2 {
    flex: 1;
  }

  .input3 {
    flex: 1;
  }

  .input-terms {
    width: 100%;
  }

  .input-persentage {
    width: 20%;
    margin-right: 4%;
    @media (max-width: 974px) {
      width: 100%;
    }
  }

  .uplode-img {
    width: 40%;
    @media (max-width: 974px) {
      width: 100%;
    }
  }

  .para {
    font-size: 12px;
    color: #999;
    margin: 0;
    width: 35%;
    @media (max-width: 974px) {
      font-size: 10px;
      width: 100%;
    }
  }
`;
const Card = styled.div`
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
  margin: auto;
  text-align: center;

  h2 {
    font-size: 22px;
    margin-bottom: 20px;
    color: #2a4157;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 0px;

    input[type='file'],
    input[type='text'] {
      padding: 10px;
      border: 1px solid #ccc;
      border-radius: 6px;
    }

    button {
      padding: 10px 15px;
      background-color: #ef4766;
      border: none;
      color: white;
      border-radius: 6px;
      cursor: pointer;
      font-weight: 600;
      transition: background 0.3s;

      &:hover {
        background-color: #d63c5b;
      }
    }
  }

  @media (max-width: 768px) {
    max-width: 220px;
    width: 100%;
    padding: 15px;

    h2 {
      font-size: 16px;
    }

    button {
      font-size: 12px;
      padding: 8px 12px;
    }

    input[type='file'],
    input[type='text'] {
      padding: 6px;
      font-size: 11px;
    }
  }
`;
